export enum DeductionTypeCategoryKey {
  TRADE = "TRADE",
  NON_TRADE = "NON_TRADE",
}

export interface DeductionTypeCategoryProps {
  deductionTypeCategoryId: number;
  deductionTypeCategoryKey: DeductionTypeCategoryKey;
  deductionTypeCategoryName: string;
}

export class DeductionTypeCategory {
  private readonly _deductionTypeCategoryId: number;
  private readonly _deductionTypeCategoryKey: DeductionTypeCategoryKey;
  private readonly _deductionTypeCategoryName: string;

  constructor(props: DeductionTypeCategoryProps) {
    this._deductionTypeCategoryId = props?.deductionTypeCategoryId ?? null;
    this._deductionTypeCategoryKey = props?.deductionTypeCategoryKey ?? null;
    this._deductionTypeCategoryName = props?.deductionTypeCategoryName ?? null;
  }

  public get deductionTypeCategoryId(): number {
    return this._deductionTypeCategoryId;
  }

  public get deductionTypeCategoryKey(): DeductionTypeCategoryKey {
    return this._deductionTypeCategoryKey;
  }

  public get deductionTypeCategoryName(): string {
    return this._deductionTypeCategoryName;
  }
}
